<template>
<div class="order">
    <router-view :param="param"></router-view>
</div>
</template>

<script>
import {mapActions} from 'vuex'
import {initPage} from 'common/js/mixin'

export default {
    name: 'order',
    mixins: [initPage],
    data() {
        return {
            param: {
                eventinnerid: '',
                paytype: '',
                payorderno: '',
                chname: '',
                username: '',
                parentnameone: '',
                parentnametwo: ''
            }
        }
    },
    mounted() {
        this.setParams(this._.cloneDeep(this.param))
    },
    methods: {
        ...mapActions([
            'setParams'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.order {
}
</style>
